import React from 'react';
import {
  FontColor,
  FontEmphasis,
  FontWeight,
} from '@prisjakt/ui/text/variants';
import { ContainerType } from '@prisjakt/ui/lib';
import { Currency } from 'src/components/currency';

import * as S from './styles';

type Props = {
  className?: string;
  container?: ContainerType;
  value: number | string | React.ReactNode;
  emphasis?: FontEmphasis;
  fontColor?: FontColor;
  weight?: FontWeight;
};

export const PriceLabel: React.FC<Props> = ({
  className,
  container = 'span',
  emphasis = FontEmphasis.HIGH,
  fontColor = FontColor.DARK,
  value,
  weight = FontWeight.HEAVIER,
}) => {
  return (
    <S.PriceLabel
      className={className}
      color={fontColor}
      container={container}
      emphasis={emphasis}
      weight={weight}
    >
      {typeof value === 'number' ? <Currency price={value} /> : value}
    </S.PriceLabel>
  );
};
